exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tile:hover{background:#d3d3d3}.v-toolbar__content{padding-left:0!important}", ""]);

// exports
